import { useApolloClient } from "@apollo/client";
import { useCallback } from "react";
import { useSetTreeHierarchyBatchMutation } from "./useBatchMoveTreeItems.generated.js";

export const useBatchMoveTreeItems = ({
  projectId,
  docId,
}: {
  projectId: string | null;
  docId: string | null;
}): [
  batchMove: (itemIds: string[], parentId: string) => Promise<void>,
  loading: boolean,
] => {
  const client = useApolloClient();
  const [setTreeHierarchyBatch, { loading }] = useSetTreeHierarchyBatchMutation(
    { client }
  );

  const batchMove = useCallback(
    async (itemIds: string[], parentId: string) => {
      if (!docId) return;
      await setTreeHierarchyBatch({
        variables: {
          input: {
            docId,
            projectId,
            itemIds,
            parentId,
          },
        },
      });
    },
    [docId, projectId, setTreeHierarchyBatch]
  );

  return [batchMove, loading];
};
